<template>
  <!-- 信息发布 -->
  <div class="page-solicitation">
    <!-- 列表头部 -->
    <div class="com-list-header">
      <el-form class="com-search-box" ref="form" :model="form" label-width="80px">
        <el-row :gutter="20">
          <el-col :span="6">
            <el-form-item label="服务区域 :" prop="name">
              <el-input v-model="form.name" placeholder="请输入"></el-input>
            </el-form-item>
          </el-col>

          <el-col :span="6">
            <el-form-item class="el-form-state" label="楼层 :" prop="floor">
              <el-select clearable v-model="form.floor" placeholder="请选择">
                <el-option v-for="item in floorList" :key="item.dictCode" :label="item.dictName" :value="item.dictCode">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <div class="com-head-search-btns">
        <el-button type="primary" @click="getTableList">查询</el-button>
        <el-button @click="restList">重置</el-button>
      </div>
    </div>

    <!-- 列表内容 -->
    <div class="com-list-content">
      <div class="button">
        <el-row>
          <el-button class="el-primary-border" round @click="handleCreate('add')">
            <svg-icon icon-class="add" />&nbsp;新建学生服务
          </el-button>
        </el-row>
      </div>
      <!-- 表格 -->
      <div class="table mt-20">
        <el-table ref="multipleTable" v-loading="listLoading" stripe :data="tableData">
          <el-table-column prop="name" label="服务区域" min-width="20%" show-overflow-tooltip>
          </el-table-column>

          <el-table-column prop="floor" label="楼层" min-width="20%" show-overflow-tooltip>
            <template slot-scope="scope">{{ scope.row.floor | filterType(floorList) }}</template>
          </el-table-column>

          <el-table-column prop="isOpen" label="是否开放讲解预约" min-width="15%">
            <template slot-scope="scope">{{ scope.row.isOpen | filterIsOpen }}</template>
          </el-table-column>
          <el-table-column prop="numStudent" label="可预约名额" min-width="15%">
          </el-table-column>

          <!-- 操作 -->
          <el-table-column fixed="right" label="操作" min-width="15%">
            <template slot-scope="scope">
              <a class="m-btn mr-10" @click="handleCreate('edit', scope.row.id)">编辑</a>
              <!-- <a class="m-btn mr-10 m-danger" @click="handleDelete(scope.row.id)">删除</a> -->
            </template>
          </el-table-column>
        </el-table>

        <div class="pagination-container paging">
          <el-pagination :current-page="listQuery.currentPage" :page-size="listQuery.size" :total="total" background
            layout="total, prev, pager, next, sizes, jumper" @size-change="handleSizeChange"
            @current-change="handleCurrentChange" />
        </div>
      </div>

      <el-dialog class="dialog-create-plan" :title="pageType == 'add' ? '新建学生服务': '编辑学生服务'"
        :visible.sync="dialogVisible" :before-close="cancel" width="850px">
        <div class="wrap">
          <el-form class="g-form-grid" ref="addForm" :model="addForm" label-width="170px" :rules="rules">

            <el-form-item label="服务区域 :" prop="name">
              <el-input v-model="addForm.name" placeholder="请输入"></el-input>
            </el-form-item>

            <el-form-item label="楼层 :" prop="floor">
              <el-select clearable v-model="addForm.floor" placeholder="请选择">
                <el-option v-for="item in floorList" :key="item.dictCode" :label="item.dictName" :value="item.dictCode">
                </el-option>
              </el-select>
            </el-form-item>

            <el-form-item label="可预约名额 :" prop="numStudent">
              <el-input v-model="addForm.numStudent" placeholder="请输入"></el-input>
            </el-form-item>

            <el-form-item label="是否开放服务预约 :" prop="isOpen">
              <el-radio-group v-model="addForm.isOpen">
                <el-radio v-for="(item, index) in typeList" :label="item.dictCode"
                  :key="index">{{item.dictName}}</el-radio>
              </el-radio-group>
            </el-form-item>

            <!-- <h1>志愿者服务预约设置</h1> -->
            <el-form-item label="可预约时间 :" prop="weekly">
              <el-checkbox-group v-model="addForm.weekly">
                <el-checkbox-button v-for="week in weeks" :label="week.dictCode"
                  :key="week.dictCode">{{week.dictName}}</el-checkbox-button>
              </el-checkbox-group>
            </el-form-item>

            <el-form-item label="学生志愿者可预约时段 :" prop="timePeriodStudent">
              <div style="display: flex;align-items:center;margin-bottom: 20px">
                <span class="flex-1">09:30</span>

                <span class="line"></span>
                <span class="flex-1">12:30</span>
              </div>

              <div style="display: flex;align-items:center;margin-bottom: 20px">
                <span class="flex-1">13:00</span>
                <span class="line"></span>
                <span class="flex-1">16:00</span>
              </div>

              <div style="display: flex;align-items:center;margin-bottom: 20px" v-for="(item, index) in selectVal"
                :key="index">
                <el-select clearable v-model="selectVal[index].value1" placeholder="请选择"
                  @change="(time)=>{changeTimePeriod11(time, index)}">
                  <el-option v-for="item in timePeriodList[index].startTimeArr" :key="item.dictCode"
                    :label="item.dictName" :value="item.dictName">
                  </el-option>
                </el-select>

                <span class="line"></span>

                <el-select clearable v-model="selectVal[index].value2" placeholder="请选择"
                  @change="(time)=>{changeTimePeriod12(time, index)}">
                  <el-option v-for="item in timePeriodList[index].endTimeArr" :key="item.dictCode"
                    :label="item.dictName" :value="item.dictName">
                  </el-option>
                </el-select>
                <i class="el-icon-close" v-if="selectVal && selectVal.length > 1" @click='delTimePeriod(item, index,1)'
                  style="margin-left: 10px"></i>
              </div>
              <el-button type="primary" @click="addTimePeriod(1)" icon="el-icon-plus">添加</el-button>
            </el-form-item>

            <!-- <el-form-item label="学生志愿者可预约时段 :" prop="timePeriodStudent">
              <el-select style="width: 100%;" clearable multiple v-model="addForm.timePeriodStudent" placeholder="请选择">
                <el-option v-for="item in timePeriod" :key="item.dictCode" :label="item.dictName" :value="item.dictName">
                </el-option>
              </el-select>
            </el-form-item> -->

            <el-form-item label="小志愿者可预约时段 :" prop="timePeriodSmallStudent">
              <div style="display: flex;align-items:center;margin-bottom: 20px">
                <span class="flex-1"> 10:00</span>

                <span class="line"></span>
                <span class="flex-1">12:00</span>
              </div>

              <div style="display: flex;align-items:center;margin-bottom: 20px">
                <span class="flex-1"> 12:30</span>
                <span class="line"></span>
                <span class="flex-1">14:30</span>
              </div>
              <div style="display: flex;align-items:center;margin-bottom: 20px" v-for="(item, index) in selectVal1"
                :key="index">
                <el-select clearable v-model="selectVal1[index].value1" placeholder="请选择"
                  @change="(time)=>{changeTimePeriod21(time, index)}">
                  <el-option v-for="item in timePeriodList1[index].startTimeArr" :key="item.dictCode"
                    :label="item.dictName" :value="item.dictName">
                  </el-option>
                </el-select>

                <span class="line"></span>

                <el-select clearable v-model="selectVal1[index].value2" placeholder="请选择"
                  @change="(time)=>{changeTimePeriod22(time, index)}">
                  <el-option v-for="item in timePeriodList1[index].endTimeArr" :key="item.dictCode"
                    :label="item.dictName" :value="item.dictName">
                  </el-option>
                </el-select>
                <i class="el-icon-close" v-if="selectVal1 && selectVal1.length > 1"
                  @click='delTimePeriod(item, index, 2)' style="margin-left: 10px"></i>
              </div>
              <el-button type="primary" @click="addTimePeriod(2)" icon="el-icon-plus">添加</el-button>
              <!-- <el-select style="width: 100%;" clearable multiple v-model="addForm.timePeriodSmallStudent" placeholder="请选择">
                <el-option v-for="item in timePeriod" :key="item.dictCode" :label="item.dictName" :value="item.dictName">
                </el-option>
              </el-select> -->
            </el-form-item>

            <el-form-item label="不可预约日期 :" prop="noAppointmentDate">
              <el-date-picker style="width:100%" clearable v-model="addForm.noAppointmentDate" format="yyyy-MM-dd"
                value-format="yyyy-MM-dd" type="dates" placeholder="请选择"></el-date-picker>
            </el-form-item>
          </el-form>
        </div>

        <div slot="footer" class="footer mt-30">
          <el-button @click="cancel">取消</el-button>
          <el-button @click="submit('form')" type="primary" :loading="loadingSave">确定</el-button>
        </div>
      </el-dialog>

    </div>

  </div>
</template>

<script>
export default {
  data() {
    return {
      that: this,
      form: {
        name: '',
        type: '',
        floor: ''
      },
      addForm: {
        name: '',
        isOpen: '',
        floor: '',
        numStudent: '',
        timePeriodSmallStudent: [],
        timePeriodStudent: [],
        weekly: [],
        noAppointmentDate: []
      },
      selectVal: [],
      selectVal1: [],

      rules: {
        name: [
          { required: true, message: '服务名称不能为空', trigger: 'blur' },
        ],
        floor: [
          { required: true, message: '楼层不能为空', trigger: 'blur' },
        ],
        numStudent: [
          { required: true, message: '学生可预约数量', trigger: 'blur' },
        ],
        isOpen: [
          { required: true, message: '开放讲解预约不能为空', trigger: 'blur' },
        ],
      },
      listQuery: {
        currentPage: 1,
        size: 10
      },
      typeList: [{
        dictCode: 1,
        dictName: '是'
      }, {
        dictCode: 0,
        dictName: '否'
      }],
      detailId: '',
      pageType: '',
      weeks: [],
      floorList: [{ dictCode: '1', dictName: '1层' }, { dictCode: '2', dictName: '2层' }, { dictCode: '3', dictName: '3层' }],

      timePeriod: [],
      timePeriodList: [{
        startTimeArr: [],
        endTimeArr: [],
      }],

      timePeriod: [],
      timePeriodList1: [{
        startTimeArr: [],
        endTimeArr: [],
      }],
      chooseRowIds: '',
      total: 0,
      exhibitionType: '',
      tableData: [],
      temporaryData: [],
      listQuery: {
        currentPage: 1,
        size: 10
      },
      selectedVolunters: [],
      listLoading: true,
      loadingSave: false,
      dialogVisible: false,
    }
  },
  filters: {
    filterIsOpen(open) {
      if (open == 1) {
        return '是'
      } else if (open == 0) {
        return '否'
      }
    },
    filterVolunteerStatus(status, that) {
      let obj = that.levelList.filter(item => {
        return item.dictCode == status
      })

      if (obj && obj.length > 0) {
        return obj[0].dictName
      }

      return null
    },

    filterType(type, list) {
      let obj = list.filter(item => {
        return item.dictCode == type
      })

      if (obj && obj.length > 0) {
        return obj[0].dictName
      }

      return type
    },

    filterTime(time) {
      return time.slice(0, 10)
    }
  },
  methods: {
    // 初始化表格
    initList() {
      this.listLoading = true
      this.tableData = []
      this.$api.volunteer.getExhibitionList({
        ...this.form,
        serviceType: '2',
        ...this.listQuery
      }).then(res => {
        if (res.success) {
          this.tableData = res.result.records
          this.total = res.result.total
        }
        this.listLoading = false
      }).catch(err => {
        this.listLoading = false
      })
    },

    // 重置查询
    restList() {
      this.$refs['form'].resetFields()
      this.listQuery.currentPage = 1
      this.initList()
    },

    // 查询
    getTableList() {
      this.listQuery.currentPage = 1
      this.initList()
    },

    // 删除
    handleDelete(id) {
      this.$common.confirm(
        {
          title: '删除学生服务信息',
          content: '该学生服务信息将被删除，请谨慎操作'
        }, () => {
          this.$api.volunteer.deleteExhibition({ id }).then(res => {
            if (res.success) {
              this.$message.success('学生服务信息删除成功')
              this.initList()
            } else {
              this.$message.error(res.message)
            }
          })
        }
      )
    },

    addTimePeriod(type) {
      if (type == 1) {
        this.selectVal.push({ value1: '', value2: '' })
        this.timePeriodList.push({
          startTimeArr: this.timePeriod,
          endTimeArr: this.timePeriod,
        })
      } else {
        this.selectVal1.push({ value1: '', value2: '' })
        this.timePeriodList1.push({
          startTimeArr: this.timePeriod,
          endTimeArr: this.timePeriod,
        })
      }


    },

    changeTimePeriod11(val, dx) {
      if (!val) {
        if (this.selectVal[dx].value2) {
          // this.timePeriodList[dx].startTimeArr = this.timePeriod
          this.timePeriodList[dx].endTimeArr = this.timePeriod
        } else {
          this.timePeriodList[dx].startTimeArr = this.timePeriod
          this.timePeriodList[dx].endTimeArr = this.timePeriod
        }
        return
      }

      let selectedDx = 0
      this.timePeriod.map((item, index) => {
        if (item.dictName == val) {
          selectedDx = index
        }
      })
      let tempArr = JSON.parse(JSON.stringify(this.timePeriod))
      tempArr.splice(0, selectedDx + 1)
      this.timePeriodList[dx].endTimeArr = tempArr
    },

    changeTimePeriod12(val, dx) {
      if (!val) {
        if (this.selectVal[dx].value) {
          this.timePeriodList[dx].startTimeArr = this.timePeriod
        } else {
          this.timePeriodList[dx].startTimeArr = this.timePeriod
          this.timePeriodList[dx].endTimeArr = this.timePeriod
        }
        return
      }
      let selectedDx = 0
      this.timePeriod.map((item, index) => {
        if (item.dictName == val) {
          selectedDx = index
        }
      })
      let tempArr = JSON.parse(JSON.stringify(this.timePeriod))
      tempArr.splice(selectedDx)
      this.timePeriodList[dx].startTimeArr = tempArr
    },

    changeTimePeriod21(val, dx) {
      if (!val) {
        if (this.selectVal1[dx].value2) {
          // this.timePeriodList[dx].startTimeArr = this.timePeriod
          this.timePeriodList1[dx].endTimeArr = this.timePeriod
        } else {
          this.timePeriodList1[dx].startTimeArr = this.timePeriod
          this.timePeriodList1[dx].endTimeArr = this.timePeriod
        }
        return
      }

      let selectedDx = 0
      this.timePeriod.map((item, index) => {
        if (item.dictName == val) {
          selectedDx = index
        }
      })
      let tempArr = JSON.parse(JSON.stringify(this.timePeriod))
      tempArr.splice(0, selectedDx + 1)
      this.timePeriodList1[dx].endTimeArr = tempArr
    },

    changeTimePeriod22(val, dx) {
      if (!val) {
        if (this.selectVal1[dx].value) {
          this.timePeriodList1[dx].startTimeArr = this.timePeriod
        } else {
          this.timePeriodList1[dx].startTimeArr = this.timePeriod
          this.timePeriodList1[dx].endTimeArr = this.timePeriod
        }
        return
      }
      let selectedDx = 0
      this.timePeriod.map((item, index) => {
        if (item.dictName == val) {
          selectedDx = index
        }
      })
      let tempArr = JSON.parse(JSON.stringify(this.timePeriod))
      tempArr.splice(selectedDx)
      this.timePeriodList1[dx].startTimeArr = tempArr
    },

    delTimePeriod(obj, dx, type) {
      if (type == 1) {
        this.selectVal.splice(dx, 1)
        this.timePeriodList.splice(dx, 1)
      } else {
        this.selectVal1.splice(dx, 1)
        this.timePeriodList1.splice(dx, 1)
      }
    },

    handleCreate(type, id) {
      this.pageType = type
      if (id) {
        this.detailId = id
        this.getDetail()
      }
      this.dialogVisible = true
    },

    getDetail() {
      this.$api.volunteer.getExhibitionDetail({ id: this.detailId }).then(res => {
        if (res.success) {
          if (res.result) {
            if (res.result.bsVolunteerV2Exhibition) {
              let exhibitionInfo = res.result.bsVolunteerV2Exhibition
              this.addForm = exhibitionInfo
              if (exhibitionInfo.weekly) {
                this.addForm.weekly = exhibitionInfo.weekly.split(',')
              }

              if (exhibitionInfo.noAppointmentDate) {
                this.addForm.noAppointmentDate = exhibitionInfo.noAppointmentDate.split(',')
              }


              if (exhibitionInfo.timePeriodStudent) {
                let timePeriodStudent = [], selectVal = []
                timePeriodStudent = exhibitionInfo.timePeriodStudent.split(',')
                if (timePeriodStudent && timePeriodStudent.length > 0) {
                  this.timePeriodList = []
                  timePeriodStudent.map(item => {
                    let arr = item.split('-')
                    if (arr[0] != '09:30' && arr[1] != '12:30' && arr[0] != '13:00' && arr[1] != '16:00') {
                      selectVal.push({
                        value1: arr[0],
                        value2: arr[1]
                      })
                    }
                  })

                  selectVal.map(it => {
                    this.timePeriodList.push({
                      startTimeArr: this.timePeriod,
                      endTimeArr: this.timePeriod
                    })
                  })

                  this.selectVal = selectVal
                }
              }

              if (exhibitionInfo.timePeriodSmallStudent) {
                let timePeriodSmallStudent = [], selectVal1 = []
                timePeriodSmallStudent = exhibitionInfo.timePeriodSmallStudent.split(',')
                if (timePeriodSmallStudent && timePeriodSmallStudent.length > 0) {
                  this.timePeriodList1 = []
                  timePeriodSmallStudent.map(item => {
                    let arr = item.split('-')

                    if (arr[0] != '10:00' && arr[1] != '12:00' && arr[0] != '12:30' && arr[1] != '14:30') {
                      selectVal1.push({
                        value1: arr[0],
                        value2: arr[1]
                      })
                    }
                  })

                  selectVal1.map(it => {
                    this.timePeriodList1.push({
                      startTimeArr: this.timePeriod,
                      endTimeArr: this.timePeriod
                    })
                  })

                  this.selectVal1 = selectVal1
                }
                // this.addForm.timePeriodSmallStudent = exhibitionInfo.timePeriodSmallStudent.split(',')
              }
            }
          }
        }
      })
    },

    initSelectList() {
      let weeks = ['周一', '周二', '周三', '周四', '周五', '周六', '周日']
      for (let m = 1; m <= 7; m++) {
        this.weeks.push({
          dictCode: m.toString(),
          dictName: weeks[m - 1]
        })
      }
      this.$api.common.getSelectDataByKey({ key: 'add_time_interval' }).then(res => {
        if (res.success) {
          this.timePeriod = res.result
          this.timePeriodList[0].startTimeArr = this.timePeriod
          this.timePeriodList[0].endTimeArr = this.timePeriod

          this.timePeriodList1[0].startTimeArr = this.timePeriod
          this.timePeriodList1[0].endTimeArr = this.timePeriod
        }
      })
    },

    setVolunteer() {
      this.$refs.dialogAdultVolunteer.init(this.selectedVolunters)
    },

    // 表格分页
    handleSizeChange(val) {
      this.listQuery.size = val
      this.initList()
    },
    // 点击序号
    handleCurrentChange(val) {
      this.listQuery.currentPage = val
      this.initList()
    },

    handleSelectionChange(list) {
      let arr = []
      list.forEach(item => {
        arr.push(item.id)
      })
      this.chooseRowIds = arr.join(',')
    },

    cancel() {
      this.dialogVisible = false
      this.selectVal = []
      this.selectVal1 = []

      this.$refs['addForm'].resetFields()
    },

    submit() {
      let url, timePeriodStudent = ['09:30-12:30', '13:00-16:00'], timePeriodSmallStudent = ['10:00-12:00', '12:30-14:30']
      this.selectVal.map(item => {
        if (item.value1 && item.value2) {
          timePeriodStudent.push(item.value1 + '-' + item.value2)
        }
      })

      this.selectVal1.map(item => {
        if (item.value1 && item.value2) {
          timePeriodSmallStudent.push(item.value1 + '-' + item.value2)
        }
      })

      this.$refs['addForm'].validate(vaild => {
        if (vaild) {
          let param = {
            serviceType: '2',
            floor: this.addForm.floor,
            name: this.addForm.name,
            isOpen: this.addForm.isOpen,
            numStudent: this.addForm.numStudent,
            weekly: this.addForm.weekly ? this.addForm.weekly.join(',') : '',
            timePeriodSmallStudent: timePeriodSmallStudent ? timePeriodSmallStudent.join(',') : '',
            timePeriodStudent: timePeriodStudent ? timePeriodStudent.join(',') : '',
            noAppointmentDate: this.addForm.noAppointmentDate ? this.addForm.noAppointmentDate.join(',') : ''
          }

          if (this.pageType === 'edit') {
            url = 'editExhibition'
            param.id = this.detailId
          } else {
            url = 'addExhibition'
          }
          this.loadingSave = true
          this.$api.volunteer[url](param).then(res => {
            this.loadingSave = false
            if (res.success) {
              if (this.pageType === 'edit') {
                this.$message.success('学生服务编辑成功')
              } else if (this.pageType === 'add') {
                this.$message.success('新增学生服务成功')
              }
              this.cancel()
              this.initList()
            } else {
              this.$message.error(res.message)
            }
          })
            .catch(() => {
              this.loadingSave = false
            })
        }
      })
    },

    keydown(event) {
      if (event.keyCode == '13') {
        this.getTableList()
      }
    }
  },
  created() {
    this.initSelectList()
    this.initList()

    window.addEventListener('keyup', this.keydown)

  }
}
</script>

<style lang="scss" scoped>
.flex-1 {
  box-sizing: border-box;
  border: 1px solid #ebedf2;
  border-radius: 20px;
  padding-left: 16px;
}
.el-form-state {
  /deep/ .el-form-item__label {
    width: 60px !important;
  }

  /deep/ .el-form-item__content {
    margin-left: 60px !important;
  }
}
.setting-wrapper {
  min-height: 100px;
  padding: 0 15px;
  border: 1px solid #ebedf2;
  .name {
    margin-right: 10px;
  }
  .btn {
    background: #0590ff;
    padding: 5px 10px;
    color: #fff;
    cursor: pointer;
  }
}

.line {
  display: inline-block;
  width: 20px;
  height: 1px;
  background: #c0c4cc;
  padding: 0 10px;
  margin: 0 10px;
}
</style>